import axios from 'axios';
import { BASE_URL_GQL } from 'src/config';
import { GetAuthorization } from 'src/utils/localStorage';

const isHandlerEnabled = false;

const requestHandler = (request) => {
  request.headers.common['Content-Type'] = 'application/json';

  const authorization = GetAuthorization();
  if (authorization) {
    request.headers.common['Authorization'] = authorization;
  } else {
    request.headers.common['Authorization'] = 'Basic NWY2YmY1ZjNhYTMxZDRjMzA5NjM0MjAyOmFwcFNlY3JldDE=';
  }

  return request;
};

const successHandler = (response, isHandlerEnabled) => {
  if (isHandlerEnabled) {
    console.info('Response success:', response);
  }

  return response;
};

const errorHandler = (error, isHandlerEnabled) => {
  if (isHandlerEnabled) {
    console.error('Response error', error);
  }
  const exceptionHandler = {
    error: 'server_error',
    error_description: 'An error has occurred, please contact the admin!'
  };

  return Promise.reject({
    ...(error && error.response && error.response.data ? error.response.data : exceptionHandler)
  });
};

export default class Service {
  constructor(namespace) {
    this.namespace = namespace;
    this.axios = axios.create({
      baseURL: BASE_URL_GQL
    });
    this.cancelTokenMap = {};
    //Enable request interceptor
    this.axios.interceptors.request.use(
      (request) => requestHandler(request, isHandlerEnabled),
      (error) => errorHandler(error, isHandlerEnabled)
    );

    //Response and Error handler
    this.axios.interceptors.response.use(
      (response) => successHandler(response, isHandlerEnabled),
      (error) => errorHandler(error, isHandlerEnabled)
    );
  }

  /**
   * Post Http Request
   * @param {any} query
   */
  post(query, { cancelQueue } = {}) {
    return new Promise((resolve, reject) => {
      let options = {};
      if (cancelQueue) {
        if (this.cancelTokenMap[cancelQueue]) {
          this.cancelTokenMap[cancelQueue].cancel('Operation canceled by the user.');
        }
        let source = axios.CancelToken.source();
        options = {
          cancelToken: source.token
        };
        this.cancelTokenMap[cancelQueue] = source;
      }

      this.axios
        .post('', query, options)
        .then((response) => {
          if (response && response.data) {
            if (response.data.errors && response.data.errors.length > 0) {
              let msg = response.data.errors.map((err) => err.message).join(',');
              reject(msg);
            } else {
              resolve(response.data);
            }
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          if (error && error.response && error.response.data && error.response.data.errors) {
            let msg = error.response.data.errors.map((err) => err.message).join(',');
            reject(msg);
          } else if (Array.isArray(error)) {
            let msg = error.map((err) => err.message).join(',');
            reject(msg);
          } else reject(error);
        });
    });
  }
}
